import { gql } from '@apollo/client';

export const RESET_FINGERPRINT = gql`
  mutation ResetFingerprint($userId: ID!) {
    resetFingerprint(userId: $userId)
  }
`; 